// Types

export const INSERIR_ROTA = "cabecalhoPagina/INSERIR_ROTA";
export const ATUALIZAR_ROTA_MENU = "cabecalhoPagina/ATUALIZAR_ROTA_MENU";
export const LIMPAR_ROTAS = "cabecalhoPagina/LIMPAR_ROTAS";

// Reducer

const INITIAL_STATE = {
  rotaMenu: "",
  rotasSubmenus: []
};

export default function reducer(state = INITIAL_STATE, action) {
  switch (action.type) {
    case INSERIR_ROTA:
      if (state.rotasSubmenus.includes(action.payload)) {
        return state;
      }

      const novaRota = [...state.rotasSubmenus];
      novaRota.push(action.payload);
      return {
        ...state,
        rotasSubmenus: novaRota
      };
    case ATUALIZAR_ROTA_MENU:
      return {
        ...state,
        rotaMenu: action.payload
      };
    case LIMPAR_ROTAS:
      return {
        ...state,
        rotasSubmenus: []
      };

    default: {
      return state;
    }
  }
}

// Action creators

export const inserirRota = rota => {
  return {
    type: INSERIR_ROTA,
    payload: rota
  };
};

export const limparRotas = () => {
  return {
    type: LIMPAR_ROTAS
  };
};

export const atualizarRotaMenu = rota => {
  return {
    type: ATUALIZAR_ROTA_MENU,
    payload: rota
  };
};
